import { Injectable } from '@angular/core';
import { Credentials } from './credentials';
import { PopoverController } from 'ionic-angular';
import { Deferred } from 'prophecy/src/Deferred';
import { Observable, Observer } from 'rxjs';
import { Router } from '@angular/router';
import { OktaAuth, IDToken, AccessToken } from '@okta/okta-auth-js';

declare let jwt_decode: any;
// declare let AWS: any;
declare let AWSCognito: any;

// FIXME: make this a config?
// maybe like this? https://stackoverflow.com/q/39576991
//
// Hub Sydney
// const userPoolId = 'ap-southeast-2_8pxvI4ExQ';
// const clientId = '2s0itv4t7a3uh7ogrlbv3jt0tm';
//
// Hub Ohio
// const userPoolId = 'us-east-2_qXsZEH5yI';
// const clientId = '533odfocqshfm3aipkukckmubk';
//
// Hub old US
// const userPoolId = 'us-east-2_Be3PeYlHI';
// const clientId = '2hg9ebtgbv5qo880bktahg382u';


@Injectable()
export class CredentialsService {
  credentials: Credentials;
  waitedForLoad = false;

  // Dev and Test
  // CLIENT_ID = '0oag83h9zMSyzbtSP3l6';
  // ISSUER = 'https://rendernetworks-dev-4010329.okta.com/oauth2/default'
  // Prod
  CLIENT_ID = '0oa1hrqwc4K34gpmt5d7';
  ISSUER = 'https://auth.produs.rendernetworks.com/oauth2/aus1hrr6oo5aIWnfv5d7';

  // Don't use the following for deployment - if you do you will get a confusing Broswer error like:
  // "AuthSdkError: Unable to retrieve OAuth redirect params from storage"
  //
  // LOGIN_REDIRECT_URI = 'http://localhost:9000/';
  // LOGOUT_REDIRECT_URI = 'http://localhost:9000/';
  // LOGIN_REDIRECT_URI = 'https://hub.dev.rendernetworks.com/';
  // LOGOUT_REDIRECT_URI = 'https://hub.dev.rendernetworks.com/';
  // LOGIN_REDIRECT_URI = 'https://hub.test.rendernetworks.com/';
  // LOGOUT_REDIRECT_URI = 'https://hub.test.rendernetworks.com/';
  LOGIN_REDIRECT_URI = 'https://hub.produs.rendernetworks.com/';
  LOGOUT_REDIRECT_URI = 'https://hub.produs.rendernetworks.com/';

  oktaAuth = new OktaAuth({
    clientId: this.CLIENT_ID,
    issuer: this.ISSUER,
    redirectUri: this.LOGIN_REDIRECT_URI,
    pkce: true
  });
  $isAuthenticated: Observable<boolean>;
  private observer?: Observer<boolean>;

  constructor(
      public popoverCtrl: PopoverController,
      private router: Router) {
    this.credentials = new Credentials('', '', '');
    this.$isAuthenticated = new Observable((observer: Observer<boolean>) => {
      this.observer = observer;
      this.isAuthenticated().then(val => {
        observer.next(val);
      });
    });
  }

  async isAuthenticated() {
    // Checks if there is a current accessToken in the TokenManger.
    return !!(await this.oktaAuth.tokenManager.get('accessToken'));
  }

  login() {
    if (this.credentials.idToken !== null && this.credentials.idToken !== '') {
      return;
    }
    // Save current URL before redirect
    sessionStorage.setItem(
      'okta-app-url',
      this.router.url);

    // Launches the login redirect.
    this.oktaAuth.token.getWithRedirect({
      scopes: ['openid', 'email', 'profile']
    });
  }

  async handleAuthentication() {
    const tokenContainer = await this.oktaAuth.token.parseFromUrl();

    this.oktaAuth.tokenManager.add('idToken', tokenContainer.tokens.idToken as IDToken);
    this.oktaAuth.tokenManager.add('accessToken', tokenContainer.tokens.accessToken as AccessToken);

    // if () {
    //   this.login();
    // }

    this.credentials.email = '';
    this.credentials.password = '';
    this.credentials.idToken = 'Bearer ' + tokenContainer.tokens.accessToken.value;
    this.credentials.settings = {};
    this.credentials.readOnly = true;
    if (await this.isAuthenticated()) {
      this.observer?.next(true);
    }

    // Retrieve the saved URL and navigate back
    const url = sessionStorage.getItem('okta-app-url') as string;
    this.router.navigateByUrl(url);
  }

  async logout() {
    sessionStorage.setItem('okta-app-url', this.LOGOUT_REDIRECT_URI);
    let idToken = await this.oktaAuth.tokenManager.get('idToken') as IDToken;
    let accessToken = await this.oktaAuth.tokenManager.get('accessToken') as AccessToken;
    await this.oktaAuth.signOut({
      revokeAccessToken: true,
      idToken: idToken,
      accessToken: accessToken,
      postLogoutRedirectUri: this.LOGOUT_REDIRECT_URI
    })
    .catch((err) => {
      console.log(err);
    });
    this.oktaAuth.tokenManager.clear();
  }

  getCredentials() {
    let deferredPromise = new Deferred();
    if (
        this.credentials != undefined &&
        this.credentials.idToken !== null &&
        this.credentials.idToken !== '') {
      deferredPromise.resolve(this.credentials);
    }
    else {
      setTimeout(() => {
        this.getCredentials().then((data) => {
          deferredPromise.resolve(data);
        });
      }, 2000);
    }
    return deferredPromise.promise;
  }

}



// WEBPACK FOOTER //
// ./src/app/credentials.service.ts